<template>
  <div class="hero-full-content" :class="{'is-open': isOpen}">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "HeroFullContent",
    props: {
      isOpen: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
